import React, { Component } from "react";
import "./Layout.css";
import { connect } from "react-redux";
import Sidebar from "../../components/Sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import NavbarBody from "../../components/UI/Navbar/NavbarBody";
import { Layout, Breadcrumb } from "antd";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { VERSION } from "../../constants/constants";

const { Content, Footer } = Layout;

class ParentLayout extends Component {
  checkRoute = (url) => {
    const checkIfPathnameIncludesUrl =
      this.props.history.location.pathname.includes(url);
    return checkIfPathnameIncludesUrl;
  };

  getPath = () => {
    const pathName = this.props.history.location.pathname;
    return pathName.replace(/\/./,`/ ${pathName.charAt(1).toUpperCase()}`);
  } 

  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    let breadCrumb = {};
    if (this.checkRoute("/pregled-registara")) {
      breadCrumb.activeKey = "2";
      breadCrumb.routeName = "Odabir registra";
    } else if (this.checkRoute("/pregled-registra/obrazac")) {
      breadCrumb.activeKey = "2";
      breadCrumb.routeName = (
        <>
          <Link to="/pregled-registara">Odabir registra</Link> / Pregled
          registara
        </>
      );
    } else if (this.checkRoute("/azuriraj/")) {
      breadCrumb.activeKey = "2";
      breadCrumb.routeName = (
        <>
          <Link to="/pregled-registara">Odabir registra</Link> /
          <Link onClick={this.goBack}> Pregled registara</Link>/ Ažuriranje
          registara bez zahtjeva
        </>
      );
    } else if (this.checkRoute("/azuriraj-po-zahtjevu")) {
      breadCrumb.activeKey = "2";
      breadCrumb.routeName = (
        <>
          <Link to="/pregled-registara">Odabir registra</Link> /
          <Link onClick={this.goBack}> Pregled registara</Link> / Ažuriranje
          registara po zahtjevu
        </>
      );
    } else if (this.checkRoute("/unos-zahtjeva")) {
      breadCrumb.activeKey = "3";
      breadCrumb.routeName = "Unos zahtjeva";
    } else if (this.checkRoute("/unos-zahtjeva/obrazac/")) {
      breadCrumb.activeKey = "3";
      breadCrumb.routeName = (
        <>
          <Link to="/pregled-obrazaca">Pregled obrazaca</Link> / Unos zahtjeva
        </>
      );
    } else if (this.checkRoute("/pregled-zahtjeva")) {
      breadCrumb.activeKey = "4";
      breadCrumb.routeName = "Pregled zahtjeva";
    } else if (this.checkRoute("/odobrenje-zahtjeva")) {
      breadCrumb.activeKey = "5";
      breadCrumb.routeName = "Odobrenje zahtjeva";
    } else if (this.checkRoute("/kreiranje-rjesenja/obrazac")) {
      breadCrumb.activeKey = "5";
      breadCrumb.routeName = (
        <>
          <Link to="/odobrenje-zahtjeva">Odobrenje zahtjeva</Link> / Kreiranje
          rješenja
        </>
      );
    } else if (this.checkRoute("/unos-u-registar/")) {
      breadCrumb.activeKey = "5";
      breadCrumb.routeName = (
        <>
          <Link to="/odobrenje-zahtjeva">Odobrenje zahtjeva</Link> / Unos u
          registar
        </>
      );
    } else if (this.checkRoute("/nadzorne-mjere")) {
      breadCrumb.activeKey = "6";
      breadCrumb.routeName = "Nadzorne mjere";
    } else if (this.checkRoute("/strucna-usavrsavanja")) {
      breadCrumb.activeKey = "7";
      breadCrumb.routeName = "Stručna usavršavanja";
    } else if (this.checkRoute("/pregled-strucnih-usavrsavanja")) {
      breadCrumb.activeKey = "7";
      breadCrumb.routeName = (
        <>
          <Link to="/strucna-usavrsavanja">Stručna usavršavanja</Link> / Pregled stručnih usavršavnaja
        </>
      );
    } else if (this.checkRoute("/organizatori") || this.checkRoute("/edukacije")){
      breadCrumb.activeKey = "7";
      breadCrumb.routeName = (
        <>
          <Link to="/strucna-usavrsavanja">Stručna usavršavanja</Link> {this.getPath()}
        </>
      );
    } else if (this.checkRoute("/izvjestaj")) {
      breadCrumb.activeKey = "8";
      breadCrumb.routeName = "Izvještaji";
    } else if (this.checkRoute("/evidencije")) {
      breadCrumb.activeKey = "9";
      breadCrumb.routeName = "Posebne evidencije";
    } else if (this.checkRoute("/kontakt")) {
      breadCrumb.activeKey = "10";
      breadCrumb.routeName = "Kontakt";
    } else if (this.checkRoute("/")) {
      breadCrumb.activeKey = "1";
      breadCrumb.routeName = "Početna stranica";
    }

    return (
      <>
        <Layout>
          <Layout>
            <NavbarBody />
            <Layout className={"font" + this.props.fontSize}>
              <Sidebar selectedKey={breadCrumb.activeKey} />
              <Layout
                className={`${this.props.isAuthenticated ? "" : "site-layout"}`}
              >
                <Content className="main-content" style={{ margin: "0 10px" }}>
                  <Breadcrumb style={{ margin: "8px 0" }}>
                    <Breadcrumb.Item>
                      <h1>
                        {breadCrumb.routeName}
                      </h1>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item></Breadcrumb.Item>
                  </Breadcrumb>
                  <div
                    className="site-layout-background"
                    style={{
                      padding: 24,
                      margin: 0,
                      minHeight: 280,
                    }}
                  >
                    {this.props.children}
                  </div>
                  <ToastContainer
                    className="toastCont"
                    pauseOnFocusLoss={true}
                    pauseOnHover={true}
                    autoClose={7000}
                  />
                </Content>
                <Footer style={{ textAlign: "center" }}>
                  <div className="focusable">
                    <a href="https://mfin.gov.hr/">
                      Ministarstvo financija Republike Hrvatske
                    </a>
                  </div>
                  <p>&copy; 2021 ({VERSION})</p>
                </Footer>
              </Layout>
            </Layout>
          </Layout>
        </Layout>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    messageId: state.authentication.userData
      ? state.authentication.userData.inResponseTo
      : "",
    error: state.formData.error,
    notificationMessage: state.formData.notificationMessage,
    notificationType: state.formData.notificationType,
    isAuthenticated: state.authentication.isAuthenticated,
    fontSize: state.layout.fontSize,
  };
};

export default withRouter(connect(mapStateToProps)(ParentLayout));
